
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CrayonSubscriptionStatus } from 'enums/CrayonSubscriptionStatus';
import { Model, ModelProperty } from 'models/Model';


export class SubscriptionDetailsModel extends Model<SubscriptionDetailsModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', isHidden: true },
		{ name: 'quantity', type: 'number' },
		{ name: 'name', type: 'string' },
		{ name: 'status', type: 'CrayonSubscriptionStatus' },
		{ name: 'orderId', type: 'string' },
		{ name: 'creationDate', type: 'Date' },
		{ name: 'billingCycle', type: 'BillingCycleEnum' },
		{ name: 'startDate', type: 'Date' },
		{ name: 'endDate', type: 'Date' },
		{ name: 'termDuration', type: 'string' },
		{ name: 'productName', type: 'string' },
		{ name: 'autoRenewEnabled', type: 'boolean' },
		{ name: 'subscriptionId', type: 'string' }
	];
	[key: string]: any;
	
	public id: number;
	public quantity: number;
	public name: string;
	public status: CrayonSubscriptionStatus;
	public orderId: string;
	public creationDate?: Date;
	public billingCycle: BillingCycleEnum;
	public startDate?: Date;
	public endDate?: Date;
	public termDuration: string;
	public productName: string;
	public autoRenewEnabled?: boolean;
	public subscriptionId: string;
    
	constructor(){
		super();
		this.id = 0;
		this.quantity = 0;
		this.name = '';
		this.status = 0;
		this.orderId = '';
		this.creationDate = undefined;
		this.billingCycle = 0;
		this.startDate = undefined;
		this.endDate = undefined;
		this.termDuration = '';
		this.productName = '';
		this.autoRenewEnabled = undefined;
		this.subscriptionId = '';
		
	}
	getProperties(){
		return SubscriptionDetailsModel.classProperties;
	}
}

export enum BillingCycleEnum{
	Unknown = 0,
	Monthly = 1,
	Annual = 2,
	None = 3,
	OneTime = 4,
	BiAnnually = 5,
	TwoYears = 7,
	ThreeYears = 8,
	Quarterly = 9
}
export namespace BillingCycleEnum {
	export function getKeys(): Map<BillingCycleEnum, string> {
		return new Map([[0, 'Unknown'], [1, 'Monthly'], [2, 'Annual'], [3, 'None'], [4, 'OneTime'], [5, 'BiAnnually'], [7, 'TwoYears'], [8, 'ThreeYears'], [9, 'Quarterly']]);
	}
}
